import axios from 'axios';

import { API_CONFIG } from 'constants/config';
import { handleErrors } from 'utils/api';
import { createActionType } from 'utils/redux';
import { apiGetCampaigns, apiDuplicateCampaign } from 'constants/apiRouting';
import { GET_CAMPAIGNS, CREATE_CAMPAIGN, UPDATE_CAMPAIGN } from 'constants/analytics';
import { analyticsTrack } from '../../utils/analytics';


// object
export const CREATE_CAMPAIGN_PENDING = 'CREATE_CAMPAIGN_PENDING';
export const CREATE_CAMPAIGN_FAIL = 'CREATE_CAMPAIGN_FAIL';
export const CREATE_CAMPAIGN_SUCCESS = 'CREATE_CAMPAIGN_SUCCESS';
export const GET_CAMPAIGN_PENDING = 'GET_CAMPAIGN_PENDING';
export const GET_CAMPAIGN_FAIL = 'GET_CAMPAIGN_FAIL';
export const GET_CAMPAIGN_SUCCESS = 'GET_CAMPAIGN_SUCCESS';
export const UPDATE_CAMPAIGN_PENDING = 'UPDATE_CAMPAIGN_PENDING';
export const UPDATE_CAMPAIGN_FAIL = 'UPDATE_CAMPAIGN_FAIL';
export const UPDATE_CAMPAIGN_SUCCESS = 'UPDATE_CAMPAIGN_SUCCESS';
export const DUPLICATE_CAMPAIGN = createActionType('DUPLICATE_CAMPAIGN');
export const RESET_CAMPAIGN = 'RESET_CAMPAIGN';
// objects
export const GET_CAMPAIGNS_PENDING = 'GET_CAMPAIGNS_PENDING';
export const GET_CAMPAIGNS_FAIL = 'GET_CAMPAIGNS_FAIL';
export const GET_CAMPAIGNS_SUCCESS = 'GET_CAMPAIGNS_SUCCESS';
export const GET_CLIENT_CAMPAIGNS = createActionType('GET_CLIENT_CAMPAIGNS');
export const UPDATE_CREATE_CAMPAIGN_STATE = 'UPDATE_CREATE_CAMPAIGN_STATE';


export const createCampaign = (params = {
  name: null,
  account: null,
  status: null,
  email_service_provider_config_id: null,
  subscription: null,
  products: null,
  campaign_manager: null,
  user_groups: null,
  organization: null,
}) => async (dispatch) => {
  dispatch({
    type: CREATE_CAMPAIGN_PENDING,
    payload: {},
  });

  // eslint-disable-next-line no-undef
  analyticsTrack(CREATE_CAMPAIGN, params, true);

  try {
    const response = await axios.post(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}campaigns/`,
      params,
      { withCredentials: true },
    );
    dispatch({
      type: CREATE_CAMPAIGN_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};

export const resetCampaign = () => (dispatch) => {
  dispatch({
    type: RESET_CAMPAIGN,
    payload: {},
  });
};

export const getCampaign = campaignId => async (dispatch) => {
  dispatch({
    type: GET_CAMPAIGN_PENDING,
    payload: {},
  });
  try {
    const response = await axios.get(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}campaigns/${campaignId}/`,
      { withCredentials: true },
    );
    dispatch({
      type: GET_CAMPAIGN_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};

export const setCampaign = campaign => (dispatch) => {
  dispatch({
    type: GET_CAMPAIGN_SUCCESS,
    payload: campaign,
  });
};


export const updateCampaign = (
  campaignId,
  params = {
    name: null,
    account: null,
    status: null,
    subscription: null,
    errors: null,
    response_email_forwards: null,
    stat_people: null,
    stat_opens: null,
    stat_delivered: null,
    stat_replies: null,
    total_number_of_emails_per_day: null,
    delay_between_each_email_sent: null,
  },
  seamless = false,
) => async (dispatch) => {
  dispatch({
    type: UPDATE_CAMPAIGN_PENDING,
    // we've disabled loading if 'seamless' option is present because we need seamless inline editing or etc
    payload: seamless ? { ...params, loading: false, loaded: true } : params,
  });

  analyticsTrack(UPDATE_CAMPAIGN, {
    campaign: campaignId,
    ...params,
  }, true);

  try {
    const response = await axios.patch(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}campaigns/${campaignId}/`,
      params,
      { withCredentials: true },
    );
    dispatch({
      type: UPDATE_CAMPAIGN_SUCCESS,
      // and this will ensure that data is in sync with backend
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};

export const resetCampaigns = () => async (dispatch) => {
  dispatch({
    type: GET_CAMPAIGN_SUCCESS,
    payload: {},
  });
  dispatch({
    type: GET_CAMPAIGNS_SUCCESS,
    payload: { results: [] },
  });
  dispatch({
    type: GET_CLIENT_CAMPAIGNS.success,
    payload: { results: [] },
  });
};


export const getCampaigns = (
  params = {
    search: null,
    status: null,
    page: null,
    account__id: null,
    campaign_manager__id: null,
    ordering: null,
  },
  seamless = false,
  cancelToken,
) => async (dispatch) => {
  dispatch({
    type: GET_CAMPAIGNS_PENDING,
    // we've disabled loading if 'seamless' option is present because we need seamless ordering
    payload: seamless ? { ...params, loading: false, loaded: true } : params,
  });

  analyticsTrack(GET_CAMPAIGNS, params, true);

  try {
    const response = await axios.get(apiGetCampaigns(), { params, withCredentials: true, cancelToken });
    dispatch({
      type: GET_CAMPAIGNS_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    if (!axios.isCancel(error)) {
      handleErrors(error, dispatch);
    }
  }
  return null;
};

export const getClientCampaigns = params => (dispatch) => {
  dispatch({
    type: GET_CLIENT_CAMPAIGNS.name,
    payload: axios.get(
      apiGetCampaigns(),
      { params, withCredentials: true },
    ).catch(error => handleErrors(error, dispatch)),
  });
};

export const duplicateCampaign = id => dispatch => dispatch({
  type: DUPLICATE_CAMPAIGN.name,
  payload: axios.get(
    apiDuplicateCampaign(id),
    { withCredentials: true },
  ).catch(error => handleErrors(error, dispatch)),
});

export const setCampaignBuilderOpen = value => dispatch => dispatch({
  type: UPDATE_CREATE_CAMPAIGN_STATE,
  payload: { openCampaignBuilder: value },
});

export const setSequenceBuilderOpen = value => dispatch => dispatch({
  type: UPDATE_CREATE_CAMPAIGN_STATE,
  payload: { openSequenceBuilder: value },
});

export const setAddEmailConfigOpen = value => dispatch => dispatch({
  type: UPDATE_CREATE_CAMPAIGN_STATE,
  payload: { openAddEmailConfig: value },
});
